import React, { useState } from 'react';
import VoucherCard from '../gift-cards-v2/VoucherCard';
import { buildPreviewVoucher } from './shopUtils';

const VISIBLE_LIMIT = 8;

// StepDesign — gallery of the designs this voucher offers, each a real
// (read-only) rendered card so the buyer picks the actual artwork. Caps the
// grid at VISIBLE_LIMIT with a "show all" expander so a big library doesn't
// bury the rest of the form (the selected design always stays visible).
const StepDesign = ({ designs, selectedDesignId, amount, currency, salonName, onChange }) => {
  const [showAll, setShowAll] = useState(false);
  if (!designs.length) return null;

  const hasMore = designs.length > VISIBLE_LIMIT;
  let shown = designs;
  if (!showAll && hasMore) {
    shown = designs.slice(0, VISIBLE_LIMIT);
    if (selectedDesignId && !shown.some(d => d.id === selectedDesignId)) {
      const sel = designs.find(d => d.id === selectedDesignId);
      if (sel) shown = [sel, ...shown.slice(0, VISIBLE_LIMIT - 1)];
    }
  }

  return (
    <section className="gcs-step">
      <div className="gcs-design-grid">
        {shown.map((d) => {
          const active = d.id === selectedDesignId;
          return (
            <button
              key={d.id}
              type="button"
              className={`gcs-design ${active ? 'is-active' : ''}`}
              onClick={() => onChange(d.id)}
              aria-pressed={active}
              aria-label={d.label}
            >
              <div className="voucher-v2 gcs-design-thumb">
                <VoucherCard
                  voucher={buildPreviewVoucher(d, amount)}
                  aesthetic={d.aesthetic}
                  salonName={salonName}
                  currency={currency}
                  showPromo={false}
                />
              </div>
            </button>
          );
        })}
      </div>
      {hasMore && (
        <button type="button" className="gcs-show-all" onClick={() => setShowAll(s => !s)}>
          {showAll ? 'Show fewer designs' : `Show all ${designs.length} designs`}
        </button>
      )}
    </section>
  );
};

export default StepDesign;
